import KeyCodes from "./key-codes.js";

const focusableElementSelectors =
  "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
const skipTabFocusSelector = 'data-skip-tab-focus';

function isVisible(item) {
  return !!( item.offsetWidth || item.offsetHeight || item.getClientRects().length);
}

function excludeDisplayNone(list) {
  let updatedListArray = new Array();

  list.forEach(function (item) {
    if (isVisible(item) && item.getAttribute(skipTabFocusSelector) != "true") {
      updatedListArray.push(item);
    }
  })
  return updatedListArray;
}

function indexOfFocusedItem(list, focusedItem) {
  let index = -1;
  for (let i = 0; i <  list.length; i++ ) {
    if (list[i].isEqualNode(focusedItem)) {
      index = i;
    }
  }

  return index;
}

// el: a dom or jquery element
// e: an event object
export default function(el, e) {
  e.preventDefault();
  if (e.keyCode != KeyCodes.TAB) { return }

  let focusableItems = el.querySelectorAll(`${focusableElementSelectors}`);
  focusableItems = excludeDisplayNone(Array.from(focusableItems));

  let focusedItem = document.activeElement;

  const numberOfFocusableItems = focusableItems.length;
  const focusedItemIndex = indexOfFocusedItem(focusableItems, focusedItem);

  let index = 0;
  if (e.shiftKey) {
    index = focusedItemIndex == 0 ? numberOfFocusableItems - 1 : focusedItemIndex - 1;
  } else {
    index = focusedItemIndex == numberOfFocusableItems - 1 ? 0 : focusedItemIndex + 1;
  }

  focusableItems[index].focus();
}
